import * as types from '../constants/userdetails';
import * as toasterTypes from '../constants/ActionTypes';

export function clearToasters() {
    return dispatch => {dispatch({type: toasterTypes.DISPLAY_DONE});}
}

export function successToasters(msg) {
    // console.log('successToaster',msg);
    return dispatch => {dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: msg });}
}

export function warningToasters(msg) {
    return dispatch => {dispatch({ type: toasterTypes.DISPLAY_WARNING, message: msg });}
}

export function errorToasters(msg) {
    return dispatch => {dispatch({ type: toasterTypes.DISPLAY_ERROR, message: msg });}
}


// WEBPACK FOOTER //
// ./actions/toaster.js